import React from 'react';
import './SkillsSummary.css';
import PrtButton from './PrtButton';

function SkillsSummary() {
  return (
    <div className="skills-summary">
      <header>
        <PrtButton label="Print Page" />
        <h2>Technical Skills Summary</h2>
        <p className="contact-info">
          <a href="mailto:joeitguy@gmail.com">joeitguy@gmail.com</a> • (619) 438-3236 • <a href="https://linkedin.com/in/joeitguy">LinkedIn</a>
        </p>
      </header>

      {/* Core Technical Skills */}
      <section className="skills-section">
        <ul>
          <li>Advanced SQL expertise: T‑SQL (SQL Server), PostgreSQL SQL, SOQL (Salesforce)</li>
          <li>Python automation for ETL orchestration, API integration, and data wrangling</li>
          <li>Multi‑database pipeline design: SQL Server → Postgres migrations, schema alignment, data quality checks</li>
          <li>Salesforce Certified Platform Administrator with hands‑on experience in Data 360 SQL Exploration</li>
          <li>Reporting & analytics development using Power BI, Tableau, and SSRS</li>
          <li>Cloud & DevOps tooling: Docker, Git, Jupyter Lab, VS Code, AWS/Azure fundamentals</li>
          <li>Cross‑system troubleshooting using Splunk, Jira, and log‑driven diagnostics</li>
        </ul>
      </section>

      {/* Competencies */}
      <section className="competencies">
        <h3>Core Competencies</h3>

        <div className="competency-zone">
          <h4>Data Engineering</h4>
          <ul>
            <li>ETL pipeline design, ingestion, transformation, and reliability checks</li>
            <li>Dimensional modeling fundamentals and schema‑first architecture</li>
            <li>Query optimization, indexing strategies, and performance tuning</li>
            <li>Automation scripting for repeatable data workflows</li>
          </ul>
        </div>

        <div className="competency-zone">
          <h4>Salesforce Platform</h4>
          <ul>
            <li>Salesforce Certified Platform Administrator</li>
            <li>SOQL querying, object relationships, and data modeling</li>
            <li>Flow Fundamentals: record‑triggered flows, screen flows, error handling</li>
            <li>Access Governance, validation rules, approval processes</li>
            <li>Data 360 SQL Exploration & Data Stream Fundamentals</li>
          </ul>
        </div>

        <div className="competency-zone">
          <h4>Analytics & Reporting</h4>
          <ul>
            <li>Power BI and Tableau dashboard development</li>
            <li>SSRS reporting pipelines and automated delivery</li>
            <li>KPI modeling, metric design, and stakeholder‑focused insights</li>
            <li>Cross‑team collaboration with finance, operations, and engineering</li>
          </ul>
        </div>

        <div className="competency-zone">
          <h4>DevOps & Tooling</h4>
          <ul>
            <li>Containerized development using Docker</li>
            <li>Git workflows for version control and deployment</li>
            <li>CI/CD fundamentals and environment consistency</li>
            <li>Infrastructure troubleshooting using Splunk and Jira</li>
          </ul>
        </div>

        <div className="competency-zone">
          <h4>Professional Strengths</h4>
          <ul>
            <li>Clear communication of technical concepts to non‑technical teams</li>
            <li>Calm, disciplined problem‑solving rooted in Navy Corpsman training</li>
            <li>Documentation, workflow mapping, and peer mentorship</li>
            <li>Team‑first mindset with strong cross‑functional collaboration</li>
          </ul>
        </div>
      </section>
    </div>
  );
}

export default SkillsSummary;
